<template>
  <div class="attended-presentation">
    <div v-if="isLoading">
      <SkeletonLoadingBars v-for="index in 2" :key="index" />
    </div>
    <div v-else>
      <h3>{{ $t('attended') }} ({{ attendedPresentations.length }})</h3>
      <AttendedPresentationList
        v-if="attendedPresentations.length > 0"
        :list="attendedPresentations"
      />
      <EmptyList v-else />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from '@/eventBus'
import SkeletonLoadingBars from '@/components/my-quiz-answers/SkeletonLoadingBars.vue'
import * as attendedPresentationUtil from '@/utils/attendedPresentation.util'
import AttendedPresentationList from './AttendedPresentationList.vue'
import EmptyList from './EmptyList.vue'

export default {
  components: {
    AttendedPresentationList,
    EmptyList,
    SkeletonLoadingBars,
  },
  data() {
    return {
      attendedPresentations: [],
      isLoading: true,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  async mounted() {
    await this.getAttendedPresentations()

    EventBus.$on('update-attended-presentation', async () => {
      await this.getAttendedPresentations()
    })
  },
  methods: {
    async getAttendedPresentations() {
      try {
        // eslint-disable-next-line promise/avoid-new
        await new Promise((resolve) => {
          setTimeout(() => {
            const userAttendedPresentations = attendedPresentationUtil.findAttendedPresentationsByUserId(
              this.currentUser.id,
            )

            if (userAttendedPresentations.length) {
              // only get last attended presentation
              this.attendedPresentations = userAttendedPresentations.slice(-1)
            }
            resolve()
          }, 500)
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
